import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const formatDateForServer = (date: Date | null) => {
  return date ? dayjs(date).format('D/M/YYYY') : '';
};

export const getProphetStats: prophetTypes.GetProphetStats = (params) => {
  return axios.get(`/prophet/stats`, { params });
};

type QueryFnType = typeof getProphetStats;

type UseGetProphetStatsOptions = {
  pageIds: string[];
  date: Date | null;
  config?: QueryConfig<QueryFnType>;
};

export const useGetProphetStats = ({ config = {}, pageIds, date }: UseGetProphetStatsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['prophet-stats', pageIds, date],
    queryFn: () => getProphetStats({ pageIds: pageIds, date: formatDateForServer(date) }),
  });
};
